/*
 * Web tournament store — mirrors apps/mobile/src/store/tournamentStore.ts
 * but with simpler scope: web port handles setup + admin first, no live
 * scoring. Types come from @golf-app/shared so the API contract is
 * enforced across both clients.
 */

import { create } from 'zustand';
import type { EventListItem, TournamentEvent } from '@golf-app/shared';

interface TournamentState {
  events: EventListItem[];
  activeEvent: TournamentEvent | null;
  isLoading: boolean;

  setEvents: (events: EventListItem[]) => void;
  upsertEvent: (event: EventListItem) => void;
  removeEvent: (id: string) => void;
  setActiveEvent: (event: TournamentEvent | null) => void;
  setLoading: (loading: boolean) => void;
}

export const useTournamentStore = create<TournamentState>((set) => ({
  events: [],
  activeEvent: null,
  isLoading: false,

  setEvents: (events) => set({ events }),
  upsertEvent: (event) =>
    set((s) => {
      const exists = s.events.some((e) => e.id === event.id);
      return {
        events: exists
          ? s.events.map((e) => (e.id === event.id ? { ...e, ...event } : e))
          : [event, ...s.events],
      };
    }),
  removeEvent: (id) => set((s) => ({ events: s.events.filter((e) => e.id !== id) })),
  setActiveEvent: (activeEvent) => set({ activeEvent }),
  setLoading: (isLoading) => set({ isLoading }),
}));
